// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerInterestsModule_block__UTHN2","edit":"PlayerInterestsModule_edit__EUuQg","footer":"PlayerInterestsModule_footer__36Isw"};